module.exports = __webpack_public_path__ + "img/starfighter-twin-ion-engine-advanced.42aa3756.svg";